

import React, { useState } from 'react';
import { useForm, useFieldArray } from 'react-hook-form';
import { createConversation } from './apiService';
import { useNavigate } from 'react-router-dom';

export default function CreateConversationForm() {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, control, formState: { errors } } = useForm();
    const { fields, append, remove } = useFieldArray({
        control,
        name: "values"
    });

    const onSubmit = (data) => {
        setIsLoading(true); // set loading to true when the form is submitted

        createConversation(data)
            .then(response => {
                navigate(`/${response.data.id}`);
            })
            .catch(error => {
                console.log(error);
            })
            .finally(() => {
                setIsLoading(false); // set loading to false after the request is done
            });
    };

    return (
        <div className="p-4 sm:p-6">
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className='mb-12'>
                    <label className="block text-sm font-medium leading-6 text-gray-900">Job title</label>
                    <input {...register("jobTitle", { required: true })} className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                    {errors.jobTitle && <span className="text-red-500 text-sm">This field is required</span>}
                    <p className="mt-3 text-sm leading-6 text-gray-600">Specify the job title.</p>
                </div>

                <div className='mb-12'>
                    <label className="block text-sm font-medium leading-6 text-gray-900">Job description or job ad</label>
                    <textarea rows={4} {...register("jobDescription", { required: true })} className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"></textarea>
                    {errors.jobDescription && <span className="text-red-500 text-sm">This field is required</span>}
                    <p className="mt-3 text-sm leading-6 text-gray-600">Describe the day to day job and what this person would be required to do or can expect.</p>
                </div>

                <div className='mb-12'>
                    <label className="block text-sm font-medium leading-6 text-gray-900">Add some values or competencies you are looking for</label>
                    {fields.map((item, index) => (
                        <div key={item.id} className="flex items-center space-x-2">
                            <input {...register(`values.${index}`)} defaultValue='' className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm" />
                            <button type="button" onClick={() => remove(index)} className="text-gray-400 hover:bg-gray-200 hover:text-gray-800 px-2 py-1 rounded text-sm">Remove</button>
                        </div>
                    ))}
                    <button type="button" className='mt-4 bg-blue-100 text-blue-800 text-sm rounded-md px-2 py-1 hover:bg-blue-300 transition-colors duration-200' onClick={() => append("")}>Add value</button>
                    <p className="mt-3 text-sm leading-6 text-gray-600">Values are a great way to understand whether a candidate will fit in culturally to your organisation.</p>
                </div>

                <div className='mb-12'>
                    <label className="block text-sm font-medium leading-6 text-gray-900">Any additional info</label>
                    <textarea rows={4} {...register("additionalInfo")} className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"></textarea>
                    <p className="mt-3 text-sm leading-6 text-gray-600">Use this to enquire about any custom or unique requirements for the role, such as police checks and other clearances.</p>
                </div>

                <button type="submit" className="py-2 px-4 bg-indigo-600 hover:bg-indigo-500 text-white font-semibold rounded-lg shadow-md focus:outline-none">
                    {isLoading ? 'Beginning...' : 'Create conversation'}
                </button>
            </form>
        </div>
    );
}
